import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { promise } from 'protractor';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { error } from 'console';
import { finalize } from 'rxjs/operators';
import { ExamEligibilityComponent } from '../exam-eligibility/exam-eligibility.component';
@Component({
  selector: 'app-qualification-details',
  templateUrl: './qualification-details.component.html',
  styleUrls: ['./qualification-details.component.scss']
})
export class QualificationDetailsComponent implements OnInit, AfterViewInit {
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  @Input() tabName: string = '';
  dialogRef: MatDialogRef<any>;
  years: number[] = this.generateYears(1970, new Date().getFullYear());
  fileName: string;
  qualList: any;
  isDivShow: boolean;
  APIService: string;
  disabled = false;
  filteredcourseLevelList: any;
  courseLevelList: any;
  courseList: any;
  filteredcourseList: any;
  filteredboardUniList: any;
  boardUniList: any;
  filteredPassYearList: any;
  PassYearList: any;
  resultNotDec = false;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  isSaving: boolean = false;
  uploadedFile
  showotheruni = false;
  fileUploadData: any;
  id: any;
  filename: any;
  prepopulateDataAvailable: boolean = false;
  fileExt: string;
  constructor(private fb: FormBuilder, public dialog: MatDialog,
    private httpClient: HttpClient,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl; }
  @ViewChild('fileUploader') fileUploader: ElementRef;
  enable = false;
  qualificationDetailsForm: FormGroup;
  submitButton = true;
  nextButton = false;
  updateButton = false;
  deleteButton = false;
  delReadOnly = false;
  resetButton = false;
  errormessage: string;
  uploadDoc: any;
  qualificationDetailsFormArray;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  QualifyShow = false;
  ngOnInit(): void {
    this.submitButton = true;
    this.delReadOnly = false;
    this.nextButton = false;
    this.updateButton = false;
    this.resetButton = false;
    this.disabled = false;
    this.showotheruni = false;
    // this.uploadedFile =false
    this.QualifyShow = false;
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.qualificationDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuQualId: new FormControl(),
      otherUni: new FormControl(),
    });
    // this.prepopulation();

    this.getScrutiny();
    this.fetchCourseLevel();
    this.fetchPassYear();
    this.fetchCourseForQual();
    this.fetchBoardUni();
    this.getApplyData();
    this.loadsettingspage();
  }

  ngAfterViewInit(): void {
    // this.loadsettingspage();
    // this.prepopulation();
  }

  getScrutiny() {
    this.calledApi++
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if (res.status) {
        this.tabs = res.data[0].Tabs;

        if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          if (res.data[0].Tabs.includes('Qualification Details')) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }
        }
        else {
          this.disabled = true;
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        // this.disabled = true;
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }

    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  onselectPrepopulate(e) {
    let base64String: string = e.fileUploadData || '';

    // Store the file data in a component variable
    this.fileUploadData = base64String;  // Store the base64 string for later use
    let mimeType: string = base64String.split(';')[0];
    let fileExtension: string = '';
    if (mimeType.includes('pdf')) {
      fileExtension = 'pdf';
    } else if (mimeType.includes('jpeg') || mimeType.includes('jpg')) {
      fileExtension = 'jpg';
    } else if (mimeType.includes('png')) {
      fileExtension = 'png';
    } else {
      fileExtension = '';
    }

    if (!fileExtension) {
      this.filename = '';
      this.id = null;  // Don't show ID if no file is uploaded
    } else {
      this.id = e.StuQualId;
      this.filename = `${this.id}.${fileExtension}`;
    }
    this.prepopulateDataAvailable = true;
    // Show spinner and initialize other variables
    this.spinner.show();
    this.onSelectionChanged2(e);
    this.submitButton = false;
    this.delReadOnly = false;
    this.nextButton = true;
    this.updateButton = true;
    this.deleteButton = false;
    this.resetButton = true;
    this.qualificationDetailsFormArray = [];

    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          if (element.FormControlName === 'fileUploadData') {
            // this.qualificationDetailsForm.controls[element.FormControlName].setValue('', Validators.required);
          } else {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], Validators.required);
              } else {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]);
              }
            } else {
              this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);
            }
          }
        }
      });

      // Group the data by FormControlName
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });
  }

  fetchCourseLevel() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'COLVL';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }


  fetchPassYear() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'PaYr';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.PassYearList = res.data;
        this.filteredPassYearList = this.PassYearList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchCourseForQual() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'Cours';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.courseList = res.data;
        this.filteredcourseList = this.courseList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchBoardUni() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'BOARD';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }
  prepopulation() {
    // remove aftre it work
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      if (res.status) {
        res.data.StuCgpi = parseFloat(res.data.StuCgpi);
        res.data.StuPassYr = parseInt(res.data.StuPassYr);
        // if(res.da)
        if (res.data.length > 0) {
          // sessionStorage.setItem("StudentPersonalId",res.data[0].StuId);
          this.submitButton = false;
          this.delReadOnly = false;
          this.updateButton = true;
          this.nextButton = true;
          this.deleteButton = false;
          this.resetButton = true;
          this.prepopulatedatapage(res);
        } else {
          this.loadsettingspage();
        }
      } else {
        this.loadsettingspage();
      }
    })
  }

  prepopulatedatapage(e) {
    // remove omnce done 
    // alert("called QualifyDetails")
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }
        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });

    this.fetchQualDetailsForTable();
  }


  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe(async (res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', Validators.required)
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }

          } else {

            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
      await this.fetchQualDetailsForTable();
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });


  }



  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    this.fileUploadData = '';
    this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      this.fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (this.fileExt.toLowerCase() == "png" || this.fileExt.toLowerCase() == "jpg" || this.fileExt.toLowerCase() == "jpeg" || this.fileExt.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  onSelectionChangedForDecResu(value) {
    if (value === 1) {
      this.resultNotDec = false;

      this.qualificationDetailsForm.controls['StuMarksObt'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();


      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].setValidators(Validators.required);
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPassYr'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();
      // this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();

    } else {
      this.resultNotDec = true;
      this.qualificationDetailsForm.controls['StuPassYr'].setValue('');

      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setValue('')
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.controls['StuMarksObt'].setValue('')
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();

      this.qualificationDetailsForm.controls['StuMarksTot'].setValue('')
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();

      this.qualificationDetailsForm.controls['StuPercent'].setValue('')
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();

      this.qualificationDetailsForm.controls['StuCgpi'].setValue('')
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();

      this.qualificationDetailsForm.controls['StuClass'].setValue('')
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();

      this.qualificationDetailsForm.controls['fileUploadData'].setValue('')

    }
  }

  onSelectionChanged2(value) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    } else {
      this.resultNotDec = false;
    }
  }

  onSelectionChanged3(value) {
    this.delReadOnly = true;
    this.resultNotDec = true;
  }
  SubmitFormarkAsTouched() {
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.qualificationDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });
  }

  SubmitQualificationDetails() {
    if (this.qualificationDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();
    } else {

      this.Submit()
      this.saveFiles()
    }

  }

  Submit() {
    this.isSaving = true;
    this.spinner.show();
    let payload = this.qualificationDetailsForm.value;
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = payload.StuCoLvl;
    payload.StuQualStr = parseInt(payload.StuQualStr);
    payload.StuPassYr = parseInt(payload.StuPassYr);
    payload.StuMarksObt = parseInt(payload.StuMarksObt);
    payload.StuMarksTot = parseInt(payload.StuMarksTot);
    payload.fileUploadData = this.qualificationDetailsForm.value.StuCoName + '.' + this.fileExt;
    payload['StuId'] = this.StudentPersonalId;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    this.umsService.addQualificationDetails(payload).subscribe(res => {
      if (res.status) {
        this.isSaving = false;
        this.spinner.hide();
        this.fetchQualDetailsForTable();
        this.qualificationDetailsForm.reset();
        this.fileUploader.nativeElement.value = null;
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.checkEligibility('submit')
        })
      }
      else {
        this.isSaving = false;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.isSaving = false;
      this.spinner.hide();
    });
  }

  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  UpdateQualificationDetails() {

    if (this.qualificationDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();
    } else {
      this.UpdateConfirmation()

    }

  }

  UpdateConfirmation() {
    if (this.tabs) {
      const lastTab: string = this.tabs.split(', ').pop() || '';


      if (this.tabName == lastTab) {
        const data = {};
        data['message'] = 'Are You Sure You Have Updated ' + this.tabs + ' Tabs. Do You Want To Proceed?';
        data['title'] = 'Alert';
        data['icon'] = 'fa fa-question';
        this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (result === 'yes') {
            this.UpdScrtDetails();
            this.UpdateScrutiny();
            this.saveFiles();
          } else {
            this.dialogRef.close();
            // Do something else if needed
          }
        });
      }
      else {
        this.UpdateScrutiny();
        this.saveFiles();
      }
    }
    else {
      this.UpdateScrutiny();
      this.saveFiles();
    }
  }



  UpdateScrutiny() {
    this.spinner.show();
    let payload = this.qualificationDetailsForm.value;
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = payload.StuCoLvl;
    payload.StuQualStr = parseInt(payload.StuQualStr);
    payload.StuPassYr = parseInt(payload.StuPassYr);
    // payload.StuMarkListRgNo =parseInt(payload.StuMarkListRgNo);
    //  payload.StuSeatNo =parseInt(payload.StuSeatNo);
    payload.StuMarksObt = parseInt(payload.StuMarksObt);
    payload.StuMarksTot = parseInt(payload.StuMarksTot);
    //payload.StuCgpi =parseFloat(payload.StuCgpi);
    // payload.StuRgNo =parseInt(payload.StuRgNo);
    payload.fileUploadData = this.qualificationDetailsForm.value.StuCoName + '.' + this.fileExt;
    payload['StuId'] = this.StudentPersonalId;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    this.umsService.updateQualificationDetails(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.checkEligibility('update')
        })
        this.qualificationDetailsForm.reset();
        this.resultNotDec = false;
        this.submitButton = true;
        this.delReadOnly = false;
        this.nextButton = true;
        this.updateButton = false;
        this.deleteButton = false;
        this.resetButton = false;
        this.uploadedFile = false;
        this.fileUploader.nativeElement.value = null;
        this.fetchQualDetailsForTable();
        // this.umsService.openSnackbar(res.message)
        //this.ngOnInit();
        //this.next.emit();
      }
    },
    );
  }
  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();
        location.reload();
      }
      else {

      }
    })
  }
  getApplyData() {
    this.calledApi++
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.Course = res.data[0]['Course'];
        this.College = res.data[0]['College']
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  prepopulationOneDetails() {
    this.submitButton = false;
    this.delReadOnly = false;
    this.updateButton = true;
    this.nextButton = true;
    let payload = {};
    let xyz = this.qualificationDetailsForm.value.StuQualStr;
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      //  this.onSelectionChanged(xyz);
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);

          this.prepopulatedatapage(res);
        } else {
          this.loadsettingspage();
        }
      } else {
        this.loadsettingspage();
      }
    })
  }

  fetchQualDetailsForTable() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.qualList = res.data;
        if (res.data.length == 0) {
          this.isDivShow = false;
          this.nextButton = false;
        }
        else {
          this.umsService.disable4 = false;
          this.isDivShow = true;
          this.nextButton = true;
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }

    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }
  percentage() {
    const StuMarksObt = this.qualificationDetailsForm.value.StuMarksObt;
    const StuMarksTot = this.qualificationDetailsForm.value.StuMarksTot;
    var percentage = ((StuMarksObt / StuMarksTot) * 100).toFixed(2);
    // this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    if (parseInt(percentage) == 100) {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(100);
    }
    else {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    }

  }

  back() {
    this.prev.emit();
    // this.submitButton =true ;
    this.qualificationDetailsForm.reset();
    this.updateButton = false;
    this.delReadOnly = false;
    this.deleteButton = false;
    this.nextButton = true;
    this.filename = '';
    this.prepopulateDataAvailable = false;
  }


  nextTab() {
    this.qualificationDetailsForm.reset();
    this.updateButton = false;
    this.deleteButton = false;
    this.submitButton = true;
    this.nextButton = true;
    this.filename = '';
    this.prepopulateDataAvailable = false;
    if (this.qualList.length == 0) {
      this.SubmitQualificationDetails();
    } else {
      this.next.emit();
      this.updateButton = false;
      this.deleteButton = false;
      this.submitButton = true;
      this.nextButton = true;
    }

  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  onYearSelect(event: any) {
    const selectedYear = event.value;
  }


  onselectPrepopulateForDelete(e) {
    this.spinner.show();
    // this.onSelectionChanged3(e);
    this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
    this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
    this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
    this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
    this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
    this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
    this.qualificationDetailsForm.get('StuClass').markAsUntouched();
    this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
    this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
    this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
    this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
    this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
    this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
    this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
    this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
    this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
    this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
    this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
    this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
    this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
    this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
    this.qualificationDetailsForm.controls['StuClass'].clearValidators();
    this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

    this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
    this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
    this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    this.submitButton = false;
    this.delReadOnly = true;
    this.nextButton = true;
    this.updateButton = false;
    this.deleteButton = true;
    this.resetButton = true;
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          if (element.FormControlName === 'fileUploadData') {
            // Do not prepopulate the fileUploadData field
            this.qualificationDetailsForm.controls[element.FormControlName].setValue('');
          }
          else {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], Validators.required);

              } else {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]);

              }
            } else {
              this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);

            }
          }
        }
        else if (element.FormVisible == false) {
        }
      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });
  }

  deletedata(id) {
    this.updateButton = false;
    this.submitButton = true;
    // this.nextButton = true;
    this.deleteButton = false;
    this.resetButton = false;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        StuId: this.StudentPersonalId,
        StuQualId: id.StuQualId,
        LoginId: parseInt(sessionStorage.getItem('StudentRGID'))

      },
    };
    this.httpClient.delete(this.APIService + '/students/Qualification', options)
      .subscribe((s) => {
        // this.spinner.hide();http://192.168.1.102:8001/api/v1/students/Qualification
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.fetchQualDetailsForTable();
        this.dialogRef.afterClosed().subscribe(result => {
          this.qualificationDetailsForm.reset();
          this.delReadOnly = false;
          this.resultNotDec = false;
          this.isSaving = false;
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });


  }

  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Information'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.qualificationDetailsForm.value);
      } else {
        // this.next.emit();

        this.updateButton = false;
        this.deleteButton = false;
        this.submitButton = true;
        this.nextButton = true;
        this.resetButton = false;
      }
    });
  }

  resetForm() {
    this.updateButton = false;
    this.deleteButton = false;
    this.submitButton = true;
    this.nextButton = true;
    this.resetButton = false;
    this.delReadOnly = false;
    this.resultNotDec = false;
    this.prepopulateDataAvailable = false;
    this.filename = ''
    this.qualificationDetailsForm.reset();

  }

  showUploadedFile(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.fileUploadData,
        disableClose: true
      });
  }


  otherUniversity(item) {
    if (item.CdDesc == 'Other') {
      this.showotheruni = true;
    }
    else {
      this.showotheruni = false;
    }
  }

  checkEligibility(data) {
    this.spinner.show();
    let payload = {};
    payload['StudentId'] = parseInt(sessionStorage.getItem('StudentPersonalId'))
    payload['SessionNo'] = parseInt(sessionStorage.getItem('session'))
    payload['ExamId'] = 0
    payload['RegId'] = 0
    payload['RuleResult'] = 'A'
    payload['EligibilityFor'] = "PreAdmissionQualification";
    this.umsService.CheckExamEligibility(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.getEligibility(data)
      }
      else {
        this.spinner.hide();
        this.ngOnInit();
        this.isSaving = false;
        this.nextButton = true;
        // this.spinner.hide();
        // if(data == 'submit'){
        //   this.Submit()
        // }
        // else if(data == 'update'){
        //   this.UpdateConfirmation()
        // }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ngOnInit();
      this.isSaving = false;
      this.nextButton = true;
    })
  }

  getEligibility(data) {
    this.dialogRef = this.dialog.open(ExamEligibilityComponent, {
      width: '170vh',
      height: '85vh',
      disableClose: true,
      data: 'PreAdmissionQualification',
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'Continue') {
        this.ngOnInit();
        this.isSaving = false;
        this.nextButton = true;
        // if(data == 'submit'){
        //   this.Submit()
        // }
        // else if(data == 'update'){
        //   this.UpdateConfirmation()
        // }
      } else {
        this.nextButton = false;
        this.isSaving = true;
        this.fetchQualDetailsForTable();
        //  this.ngOnInit();
      }
    });
  }


  saveFiles() {
    const payload = {
      StuId: parseInt(this.StudentPersonalId,),
      files: [
        {
          fileName: this.qualificationDetailsForm.value.StuCoName + '.' + this.fileExt,
          base64Data: this.uploadDoc
        }
      ]
    };
    this.umsService.saveFilesDetails(payload).subscribe(
      res => {
        if (res.status) {
          this.spinner.hide();
        } else {
          this.isSaving = false;
          this.spinner.hide();
        }
      },
      (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.spinner.hide();
      }
    );

  }


  getFiles(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['fileNames'] = data.fileUploadData ? [data.fileUploadData] : [''];

    this.umsService.getFilesDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.umsService.disable6 = false;
      this.submitButton = false;
      this.updateButton = true;
      const files = res.files || [];
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: res.files[0].base64Data,
          disableClose: true
        });
    });
  }
  showbase64(e) {
    console.log("uuuuuuuuuuuuu", e);
    if (e.fileUploadData === null || e.fileUploadData.startsWith('data:') || e.fileUploadData == null) {
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: e.fileUploadData,
          disableClose: true
        });
    } else {
      this.getFiles(e)
    }

  }

  showbaseFile() {
    if (this.fileUploadData.startsWith('data:')) {
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: this.fileUploadData,
          disableClose: true
        });
    } else {
      this.spinner.show();
      let payload = {};
      payload['StuId'] = this.StudentPersonalId;
      payload['fileNames'] = [this.fileUploadData];
      this.umsService.getFilesDetails(payload).subscribe((res) => {
        this.spinner.hide();
        this.submitButton = false;
        this.updateButton = true;
        const files = res.files || [];
        const dialogRef3 = this.dialog.open(PdfviewerComponent,
          {
            width: "400px",
            height: "500px",
            data: res.files[0].base64Data,
            disableClose: true
          });
      });
    }
  }
}